// extracted by mini-css-extract-plugin
module.exports = {"root":"_1vjLK","pagination":"_16BXz","paginationItem":"_2xYfu","active":"_38rTM","hide":"jDSnS"};